'use client';

import { useMemo } from 'react';

import {
  CategoryDesktopLayoutTemplate,
  CategoryMobileLayoutTemplate
} from 'components/atomic/template';
import { DEVICE_SURFACE } from 'config/common';
import { GetUiDeviceSurface } from 'helpers/screenResolutionHelper';
import { getPageURL, ROUTE_CONFIG } from 'services/hostPortal.service';

const CategoryL1Client = ({
  categories,
  category,
  categorySeoDetails,
  categorySlug,
  initialProducts,
  parentCategories,
  parentCategoryName,
  parentSlug,
  priceRange,
  productsCount,
  subCategories
}) => {
  const surface = GetUiDeviceSurface();

  // Calculate breadcrumbs using useMemo instead of useEffect to avoid flashes
  const breadcrumbsInfo = useMemo(() => {
    const base = [
      {
        link: getPageURL({ pageName: ROUTE_CONFIG.HOME_PAGE.label }),
        name: 'Home'
      },
      {
        link: getPageURL({
          pageName: ROUTE_CONFIG.L0_CATEGORY.label,
          pathParams: { parentSlug }
        }),
        name: parentCategoryName
      }
    ];

    const currentCat = categories.find(({ slug }) => categorySlug === slug);
    if (currentCat) {
      base.push({
        link: getPageURL({
          pageName: ROUTE_CONFIG.L1_CATEGORY.label,
          pathParams: { categorySlug, parentSlug }
        }),
        name: currentCat.name
      });
    }
    return base;
  }, [categorySlug, categories, parentSlug, parentCategoryName]);

  const categoryLayoutMap = {
    [DEVICE_SURFACE.MOBILE]: CategoryMobileLayoutTemplate,
    [DEVICE_SURFACE.WEB]: CategoryDesktopLayoutTemplate
  };

  const CategoryLayout = categoryLayoutMap[surface];

  return (
    <CategoryLayout
      {...{
        breadcrumbsInfo,
        categories,
        category,
        categorySeoDetails,
        categorySlug,
        initialProducts,
        parentCategories,
        parentCategoryName,
        parentSlug,
        priceRange,
        productsCount,
        showProductSubCategory: true,
        subCategories
      }}
    />
  );
};

export default CategoryL1Client;
